import { makeStyles } from "tss-react/mui"
import { Checkbox, FormControlLabel, FormGroup, FormHelperText, Grid, Typography } from "@mui/material"
import { useFormikContext } from "formik"
import { CreateUpdateDayMenuFormValues, SignageType, SignageTypeList } from "../../menuPlanningTypes"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    container: {
        flexWrap: "nowrap",
        flexDirection: "row",
        gap: "2rem",
    },
    checkbox: {
        color: theme.palette.tailwind.slate[400],
        "&.Mui-checked": {
            color: "#2196F3",
        },
    },
}))

type SignageTypesFieldProps = Readonly<{}>

export const SignageTypesField = ({}: SignageTypesFieldProps) => {
    const { classes, cx } = useStyles()
    const { values, setFieldValue, errors } = useFormikContext<CreateUpdateDayMenuFormValues>()
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const optionValue = event.target.value as SignageType
        const isChecked = event.target.checked

        const currentSignageTypes = values.signageTypes || []
        let newSignageTypes: SignageTypeList[]

        if (isChecked) {
            newSignageTypes = currentSignageTypes.includes(optionValue)
                ? currentSignageTypes
                : [...currentSignageTypes, optionValue]
        } else {
            newSignageTypes = currentSignageTypes.filter((type) => type !== optionValue)
        }

        setFieldValue("signageTypes", newSignageTypes)
    }

    return (
        <Grid>
            <Grid container flexDirection="column">
                <LocalizedStrict id="merchant-menu-planning-dialog-signageTypes-label">
                    <Typography variant="body2" fontWeight={500}>
                        Publish to:
                    </Typography>
                </LocalizedStrict>
                <FormGroup className={classes.container}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.signageTypes?.includes(SignageType.WEB_MENU) ?? false}
                                onChange={onChange}
                                value={SignageType.WEB_MENU}
                                className={classes.checkbox}
                            />
                        }
                        label={
                            <LocalizedEnum
                                base="merchant-menu-planning-dialog-signageTypes-mode"
                                enumValue={SignageType.WEB_MENU}
                            >
                                <Typography variant="body1">{SignageType.WEB_MENU}</Typography>
                            </LocalizedEnum>
                        }
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.signageTypes?.includes(SignageType.BUFFET_SIGN) ?? false}
                                onChange={onChange}
                                value={SignageType.BUFFET_SIGN}
                                className={classes.checkbox}
                            />
                        }
                        label={
                            <LocalizedEnum
                                base="merchant-menu-planning-dialog-signageTypes-mode"
                                enumValue={SignageType.BUFFET_SIGN}
                            >
                                <Typography variant="body1">{SignageType.BUFFET_SIGN}</Typography>
                            </LocalizedEnum>
                        }
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.signageTypes?.includes(SignageType.DAY_MENU_SIGN) ?? false}
                                onChange={onChange}
                                value={SignageType.DAY_MENU_SIGN}
                                className={classes.checkbox}
                            />
                        }
                        label={
                            <LocalizedEnum
                                base="merchant-menu-planning-dialog-signageTypes-mode"
                                enumValue={SignageType.DAY_MENU_SIGN}
                            >
                                <Typography variant="body1">{SignageType.DAY_MENU_SIGN}</Typography>
                            </LocalizedEnum>
                        }
                    />
                </FormGroup>
            </Grid>
            {!!errors.signageTypes && <FormHelperText error>{errors.signageTypes}</FormHelperText>}
        </Grid>
    )
}
